// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 28) return "static/js/3d0e7b20828a0847a976.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"6a170d10b267c65b8439","150":"ebd0fec4471053a2edc3","151":"d4977e6ea84eefc344cc"}[chunkId] + ".chunk.js";
};